import styled from 'styled-components';

export const CommentAlertWrapper = styled.div`
  display: flex;
  padding: 8px 16px;
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
  margin-bottom: 16px;
`;
